// ═══════════════════════════════════════════════════════════════════
//  modules/projets/constantes.js
//  CATEGORY_LABELS · PROJECT_PRIORITY_COLORS
// ═══════════════════════════════════════════════════════════════════

export const CATEGORY_LABELS = {
  plugins: { label: "Plugins", color: "#4F8EF7", bg: "#1E3A6E" },
  site_admin: { label: "Site Admin", color: "#BC8CFF", bg: "#2D1F4E" },
  site_joueur: { label: "Site Joueur", color: "#3DDC84", bg: "#0D3320" },
  map_build: { label: "Map / Build", color: "#E3B341", bg: "#3D2D00" },
  finances: { label: "Finances", color: "#C9A84C", bg: "#3D2E10" },
  infrastructure: { label: "Infrastructure", color: "#F85149", bg: "#3D1515" },
  partenariat: { label: "Partenariat", color: "#4F8EF7", bg: "#1E3A6E" },
  prestataires: { label: "Prestataires", color: "#7D8590", bg: "#1C2333" },
  lore: { label: "Lore", color: "#BC8CFF", bg: "#2D1F4E" },
  graphisme: { label: "Graphisme", color: "#3DDC84", bg: "#0D3320" },

  // Catégories créées par l'analyse IA du chat (module chat-analysis).
  // Sans elles, une tâche remontée automatiquement s'affiche sans
  // libellé ni couleur, et reste introuvable dans les filtres — alors
  // qu'elle existe bel et bien en base.
  chat_bug: { label: "Chat · Bug", color: "#F85149", bg: "#3D1515" },
  chat_suggestion: { label: "Chat · Suggestion", color: "#E3B341", bg: "#3D2D00" },
  chat_comportement: { label: "Chat · Comportement", color: "#4F8EF7", bg: "#1E3A6E" },
};

export const PROJECT_PRIORITY_COLORS = {
  haute: { bg: "#3D1515", text: "#F85149" },
  moyenne: { bg: "#3D2D00", text: "#E3B341" },
  basse: { bg: "#1C2333", text: "#7D8590" },
};
